import React from "react";
import { Box, Text, Button } from "grommet";
import exp from "constants";
import { useNavigate } from "react-router-dom";

const BookUnitCard = (props: any) => {
    let book = props.book;
    // console.log("BookUnitCard", book)
    let navigate = useNavigate();
    const [category, setCategory] = React.useState<string>("")
    const [ready, setReady] = React.useState<boolean>(false)
    React.useEffect(() => {
        if (book) {
            setCategory(book.book_category)
            setReady(true)
            
        } else {
            setReady(false)
        }
    }, [book])
    return (
        <Box
            width="full"
            height="full"
            background="white"
            round='2px'
            border={{ color: "rgba(150,150,150)", size: "1px" }}
            margin={{ vertical: '5px' }}
            pad="3px"
        >
            {ready && <Button plain 
                onClick={() => {
                category === 'redbook' ? navigate("/redbook#" + book.book_id) : navigate("/book#" + book.book_id)
            }}
                hoverIndicator
                label={
                    <Box width="full" height="full" align="center" justify="center" pad="2px">
                        <Text size='12px'>{book.authors}</Text>
                        <Text>
                            <Text size="14px">{book.book_title}</Text>
                            <Text size='12px' margin={{ left: '5px' }}>{book.numeration}</Text>
                        </Text>
                        <Text>
                            <Text size='12px'>{book.publisher}</Text>
                            <Text size='10px' margin={{ left: '5px' }}>{book.publish_date}</Text>
                        </Text>
                    </Box>
                }
            />}

        </Box>
    );
}

export default BookUnitCard;